// StateSetupModal.jsx — first-run BetMGM state selection modal
// Spec: docs/specs/slipsync-ui.md Section 6 (valid states)

import { useState } from 'react';
import { VALID_STATES } from '../../lib/slipsync/constants';

export default function StateSetupModal({ onSave }) {
  const [selected, setSelected] = useState('');

  return (
    <div style={{
      background: '#0f172a', border: '1px solid #1e293b', borderRadius: 12,
      padding: '20px 16px', marginBottom: 16,
    }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: '#f1f5f9', marginBottom: 8 }}>
        Select your BetMGM state
      </div>
      <div style={{ fontSize: 11, color: '#64748b', marginBottom: 14 }}>
        Choose the US state where your BetMGM account is registered.
      </div>

      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 16,
      }}>
        {VALID_STATES.map((s) => (
          <button
            key={s}
            onClick={() => setSelected(s)}
            style={{
              background: selected === s ? '#4f46e5' : '#1e293b',
              border: selected === s ? '1px solid #6366f1' : '1px solid #334155',
              borderRadius: 6, padding: '6px 10px',
              color: selected === s ? '#fff' : '#94a3b8',
              fontSize: 11, fontWeight: 700, cursor: 'pointer',
              fontFamily: 'inherit', textTransform: 'uppercase',
            }}
          >
            {s}
          </button>
        ))}
      </div>

      <button
        onClick={() => { if (selected) onSave(selected); }}
        disabled={!selected}
        style={{
          background: selected ? 'linear-gradient(135deg,#1d4ed8,#4f46e5)' : '#1e293b',
          border: 'none', borderRadius: 8, padding: '10px 20px',
          color: selected ? '#fff' : '#475569', fontSize: 13, fontWeight: 700,
          cursor: selected ? 'pointer' : 'not-allowed',
          fontFamily: 'inherit', width: '100%',
        }}
      >
        Save
      </button>
    </div>
  );
}
